<template>
  <b-container>
    <b-row>
      <b-col class="result-section" cols="12" :lg="lgIf('artist')" v-if="!type || type === 'artist'">
        <div class="headline">
          <div class="title" v-if="recommended">
            Top Artists
          </div>
          <div class="title" v-else>
            Artists
          </div>
          <div class="more">
            <LinkButton :u="true" @click="type = 'artist'" v-if="!type" class="text-nowrap">See all</LinkButton>
            <LinkButton :u="true" @click="clearType" v-else>Back</LinkButton>
          </div>
        </div>
        <div class="items artists">
          <div class="wait" v-if="!artists">
            <font-awesome-icon icon="spinner" size="lg" spin />
          </div>

          <div class="empty pt-3" v-if="artists && !artists.length">
            no results
          </div>

          <div class="item artist pt-3" v-for="artist in artists" :key="artist.id" v-if="artists">
            <router-link :to="{name: 'artist-about', params: {artistId: artist.id}}">
              <img class="avatar" :src="artist.avatar_image || '/static/img/default-avatar.jpg'">
            </router-link>
            <div class="info">
              <div class="name">
                <router-link :to="{name: 'artist-about', params: {artistId: artist.id}}">
                  {{ artist.name }}
                </router-link>
              </div>
              <div class="videos">
                {{ getArtistSongCount(artist) }}
              </div>
            </div>
          </div>

        </div>
      </b-col>

      <b-col class="result-section" cols="12" :lg="lgIf('album')" v-if="!type || type === 'album'">

        <div class="headline">
          <div class="title" v-if="recommended">
            Latest Album Releases
          </div>
          <div class="title" v-else>
            Albums
          </div>
          <div class="more">
            <LinkButton :u="true" @click="type = 'album'" v-if="!type" class="text-nowrap">See all</LinkButton>
            <LinkButton :u="true" @click="clearType" v-else>Back</LinkButton>
          </div>
        </div>
        <div class="items pt-3">

          <div class="wait" v-if="!albums">
            <font-awesome-icon icon="spinner" size="lg" spin />
          </div>

          <div class="empty" v-if="albums && !albums.length">
            no results
          </div>

          <div class="item album" v-for="album in albums" :key="album.id" v-if="albums">
            <div>
              <router-link :to="{name: 'album-detail', params: {id: album.id}}">
                <img class="cover" :src="album.cover">
              </router-link>
            </div>
            <div class="info">
              <div class="artist-name">
                <router-link :to="{name: 'artist-about', params: {artistId: album.artist.id}}">{{ album.artist.name }}</router-link>
              </div>
              <div class="name">
                <router-link :to="{name: 'album-detail', params: {id: album.id}}">{{ album.title }}</router-link>
              </div>
              <div class="songs">
                {{ getPublishDate(album) }} <br> {{ getSongCount(album) }}
              </div>
            </div>
          </div>

        </div>
      </b-col>
    </b-row>

    <b-row class="pt-4" v-if="!type || type === 'song'">
      <b-col class="result-section">

        <div class="headline">
          <div class="title" v-if="recommended">
            Popular Videos
          </div>
          <div class="title" v-else>
            Videos
          </div>
          <div class="more">
            <LinkButton :u="true" @click="type = 'song'" v-if="!type" class="text-nowrap">See all</LinkButton>
            <LinkButton :u="true" @click="clearType" v-else>Back</LinkButton>
          </div>
        </div>
        <div class="items popular pt-3" v-bind:class="{ 'justify-content-start' : videos ? videos.length <= 3 : true}">

          <div class="wait" v-if="!videos">
            <font-awesome-icon icon="spinner" size="lg" spin />
          </div>

          <div class="empty" v-if="videos && !videos.length">
            no results
          </div>

          <VideoCard v-for="video in videos"
                     :key="video.id"
                     :video="video"
                     :related="allVideos"
                     :showDate="true"
                     :showArtist="true" />

        </div>
      </b-col>
    </b-row>

    <b-row class="pt-4" v-if="!type || type === 'live'">
      <b-col class="result-section">

        <div class="headline">
          <div class="title" v-if="recommended">
            Trending Live Streams
          </div>
          <div class="title" v-else>
            Live Streams
          </div>
          <div class="more">
            <LinkButton :u="true" @click="type = 'live'" v-if="!type" class="text-nowrap">See all</LinkButton>
            <LinkButton :u="true" @click="clearType" v-else>Back</LinkButton>
          </div>
        </div>
        <div class="items trending pt-3">

          <div class="wait" v-if="!live_events">
            <font-awesome-icon icon="spinner" size="lg" spin />
          </div>

          <div class="empty" v-if="live_events && !live_events.length">
            no results
          </div>

          <EventCard v-for="live in live_events"
                     class="event-card"
                     :key="live.id"
                     :live="live"
                     :withWatchlistButton="true" />

        </div>
      </b-col>
    </b-row>

    <b-row class="pt-4" v-if="!recommended && (!type || type === 'playlist')">
      <b-col class="result-section">

        <div class="headline">
          <div class="title">
            Playlists
          </div>
          <div class="more">
            <LinkButton :u="true" @click="type = 'playlist'" v-if="!type" class="text-nowrap">See all</LinkButton>
            <LinkButton :u="true" @click="clearType" v-else>Back</LinkButton>
          </div>
        </div>

        <div class="wait" v-if="!playlists">
          <font-awesome-icon icon="spinner" size="lg" spin />
        </div>

        <div class="empty pt-3" v-if="playlists && !playlists.length">
          no results
        </div>

        <PlaylistList :items="playlists" v-if="playlists && playlists.length" />

      </b-col>
    </b-row>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .result-section {

    .headline {
      display: flex;
      border-bottom: 1px solid #63637c;
      .title {
        flex: 1;
        font-weight: bold;
      }

      .more {
        text-align: right;

        /deep/ a {
          color: $white;
          text-decoration: underline;
        }

        @media (hover: hover) {
          /deep/ a:hover {
            text-decoration: none;
          }
        }
      }
    }

    .empty, .wait {
      text-align: center;
      color: $steel;
      width: 100%;
      font-size: 0.8rem;
      margin-top: 0.5em;
    }

    .items {
      display: flex;
      font-size: 0.9em;
      flex-wrap: wrap;
      justify-content: left;

      &.artists {
        justify-content: center;
      }

      .item.artist {
        margin-top: 1em;
        margin-right: 16px;
        display: block;
        align-items: center;
        width: 140px;

        img.avatar {
          display: block;
          margin: 0 auto;
          width: 96px;
          height: 96px;
          border-radius: 100%;
          box-shadow: 3px 2px 12px 0 rgba(0, 0, 0, 0.34);
        }

        .info {
          .name {
            margin-top: 0.5em;
            text-align: center;
            font-weight: bold;

            /deep/ a {
              color: white;
            }
          }

          .videos {
            color: $steel;
            text-align: center;
          }
        }
      }

      .item.album {
        margin-top: 1em;
        margin-right: 1em;
        display: flex;
        flex-direction: row;
        align-items: start;
        width: 200px;

        img.cover {
          display: block;
          width: 96px;
          height: 96px;
          box-shadow: 3px 2px 12px 0 rgba(0, 0, 0, 0.34);
        }

        .info {
          margin-left: 0.5em;
          text-align: left;

          .artist-name {
            color: $steel;

            a {
              color: $steel;
            }
          }

          .name {
            font-weight: bold;

            a {
              color: white;
            }
          }

          .songs {
            color: $steel;
          }
        }

        button {
          font-size: 0.8em;
          display: block;
          width: 100%;
          margin-top: 6px;
        }
      }
    }

    @include media-breakpoint-up(md) {
      .items.artists {
        justify-content: left;
      }
    }
    .popular {
      font-size: 1em;
    }
  }
</style>

<script>
import map from 'lodash/map'
import take from 'lodash/take'
import moment from '@/utils/moment'

import { mapGetters, mapActions } from 'vuex'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import PlaylistList from './PlaylistList'
import LinkButton from './LinkButton'
import VideoCard from './VideoCard'
import EventCard from './EventCard'

export default {
  name: 'DiscoverResults',
  components: {
    FontAwesomeIcon,
    PlaylistList,
    LinkButton,
    VideoCard,
    EventCard
  },
  props: {
    query: String,
    tag: String,
    recommended: Boolean,
    action: String
  },
  data () {
    return {
      type: null,
      artists: null,
      albums: null,
      videos: null,
      allVideos: null,
      playlists: null,
      live_events: null
    }
  },
  computed: {
    ...mapGetters('profile', ['currentUser'])
  },
  created () {
    this.search()
  },
  watch: {
    'query': 'search',
    'type': 'search',
    'recommended': 'search',
    'action': 'clearType'
  },
  methods: {
    async search () {
      this.artists = null
      this.albums = null
      this.videos = null
      this.playlists = null
      this.live_events = null

      let showAll = this.type !== null

      if (this.recommended) {
        let response = await this.$store.dispatch('search/getRecommendations')
        this.artists = showAll ? response.artists : take(response.artists, 3)
        this.albums = showAll ? response.albums : take(response.albums, 4)
        this.allVideos = response.videos
        this.videos = showAll ? this.allVideos : take(this.allVideos, 4)
        this.playlists = showAll ? response.playlists : take(response.playlists, 4)
        this.live_events = showAll ? response.live_events : take(response.live_events, 4)
        return
      }

      let filter = {}
      if (this.query) {
        filter.q = this.query
      } else if (this.tag) {
        filter.tags = this.tag
      } else {
        return
      }

      // Wait for the results and either return the first few or all
      async function waitFor (req, all) {
        const response = await req
        if (!response) return null
        return all ? response.all() : response.results
      }

      // Empty search, used if the particular type is not searched after
      let searchArtists = Promise.resolve()
      let searchAlbums = Promise.resolve()
      let searchSongs = Promise.resolve()
      let searchPlaylists = Promise.resolve()
      let searchLiveEvents = Promise.resolve()

      // Initiate search operations in parallel, only on types we need
      if (!this.type || this.type === 'artist') searchArtists = this.searchArtists(filter)
      if (!this.type || this.type === 'album') searchAlbums = this.searchAlbums(filter)
      if (!this.type || this.type === 'song') searchSongs = this.searchSongs(filter)
      if (!this.type || this.type === 'playlist') searchPlaylists = this.searchPlaylists(filter)
      if (!this.type || this.type === 'live') searchLiveEvents = this.searchLiveEvents(filter)

      // Wait for them to be complete and use the responses
      this.artists = map(await waitFor(searchArtists, !!this.type), r => r.artist)
      this.albums = map(await waitFor(searchAlbums, !!this.type), r => r.album)
      this.videos = map(await waitFor(searchSongs, !!this.type), r => r.song)
      this.allVideos = this.videos
      this.playlists = map(await waitFor(searchPlaylists, !!this.type), r => r.playlist)
      this.live_events = map(await waitFor(searchLiveEvents, !!this.type), r => r.live_event)

      if (!showAll) {
        this.artists = take(this.artists, 3)
        this.albums = take(this.albums, 4)
        this.videos = take(this.videos, 4)
        this.playlists = take(this.playlists, 4)
        this.live_events = take(this.live_events, 4)
      }
    },
    getPublishDate (album) {
      if (!album) return ''
      return moment.utc(album.release_date).format('MM/DD/YYYY')
    },
    getSongCount (album) {
      if (album.songs.length === 0) return 'no songs'
      if (album.songs.length === 1) return '1 song'
      return album.songs.length + ' songs'
    },
    getArtistSongCount (artist) {
      if (artist.video_count === 0) return 'no videos'
      if (artist.video_count === 1) return '1 video'
      return artist.video_count + ' videos'
    },
    lgIf (type) {
      return this.type === type ? 12 : 6
    },
    clearType () {
      this.type = null
    },
    ...mapActions('search', ['searchAlbums', 'searchArtists', 'searchPlaylists', 'searchSongs', 'searchLiveEvents'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/DiscoverResults.vue